(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luckiefoo-bring-it-back"] && !Shopify.designMode) return;
  try {
    
(function(){
 if(window.__lfBringItBackBound)return;window.__lfBringItBackBound=true;
 function hook(){return document.querySelector('.lf-bring-back-hook')}
 function firework(x,y){var h=hook();if(!h||h.dataset.animation!=='fu_firework')return;var f=document.createElement('span');f.className='lf-firework';f.style.transform='translate3d('+x+'px,'+y+'px,0)';for(var i=0;i<14;i++){var s=document.createElement('i');s.style.setProperty('--a',(i*(360/14)+(i%2?4:-3))+'deg');s.style.setProperty('--d',(23+(i%5)*5)+'px');f.appendChild(s)}document.body.appendChild(f);setTimeout(function(){f.remove()},1000)}
 function animate(r){var h=hook();if(!h||h.dataset.animation==='none')return;var x=Math.max(18,Math.min(innerWidth-52,r.left+r.width*.5-17)),y=Math.max(48,Math.min(innerHeight-50,r.top+r.height*.5-17));function sway(){return Math.round(Math.random()*22-11)}var end=sway(),fu=document.createElement('span');fu.className='lf-fu-flight';fu.textContent='福';fu.style.setProperty('--x0',x+'px');fu.style.setProperty('--y0',y+'px');fu.style.setProperty('--s1',sway()+'px');fu.style.setProperty('--s2',sway()+'px');fu.style.setProperty('--s3',sway()+'px');fu.style.setProperty('--s4',sway()+'px');fu.style.setProperty('--send',end+'px');document.body.appendChild(fu);requestAnimationFrame(function(){requestAnimationFrame(function(){fu.classList.add('is-flying')})});if(h.dataset.animation==='fu_firework')setTimeout(function(){firework(x+end+17,Math.max(24,y-188))},4650);setTimeout(function(){fu.remove()},5100)}
 document.addEventListener('click',function(e){
   var b=e.target&&e.target.closest?e.target.closest('.Vtl-WishlistButton__AddToWishlist'):null;
   if(!b)return;
   var r=b.getBoundingClientRect();if(r.width&&r.height)animate(r);
 },true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
